/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  (function (window) {
  // Avoid clobbering existing implementation
    if (window.publish && window.subscribe) return;
  
    const events = Object.create(null);
  
    function subscribe(name, cb) {
      if (!events[name]) events[name] = [];
      events[name].push(cb);
      // return unsubscribe function
      return () => {
        const idx = events[name].indexOf(cb);
        if (idx > -1) events[name].splice(idx, 1);
      };
    }
  
    function publish(name, payload) {
      const list = events[name];
      if (!list || !list.length) return;
      // clone so subscribers can unsubscribe while iterating
      list.slice().forEach(cb => {
        try { cb(payload); } catch (e) { console.error('PubSub handler error', e); }
      });
    }
  
    // Optional: helper exposing event names container
    const PUB_SUB_EVENTS = {
      quickAddModalShow: 'quickAddModalShow'
    };
  
    // Expose globally
    window.subscribe = subscribe;
    window.publish = publish;
    window.PUB_SUB_EVENTS = window.PUB_SUB_EVENTS || PUB_SUB_EVENTS;
  })(window);

  document.addEventListener('DOMContentLoaded', function() {
    const links = document.querySelectorAll('.blog-section .inline-nav li a');
    console.log(links);

    links.forEach((a, i) => {
      const num = (i % 5) + 1; // cycles 1–5 repeatedly
      a.classList.add(`item-${num}`);
    });

    /* promo banner conditional class */
    const header = document.querySelector(".header-sections");
    const banners = document.querySelectorAll(".about-banner, .home-banner, .blog-editorial, .blog-post-banner");

    if (header && header.querySelector(".section-countdown")) {
      banners.forEach((banner) => {
        banner.classList.add("promo-banner-active");
      });
    }
  });

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

document.addEventListener('click', function(event) {
    // Use event delegation: check if the clicked element is a slider-dot
    const clickedDot = event.target.closest('[data-ele="slider-dot"]');

    // If it's not a dot or not inside a stacked container, do nothing
    if (!clickedDot || !clickedDot.closest('[data-ele="stacked"]')) return;

    try {
        const blockId = clickedDot.getAttribute('data-slider-dot');
        const parentContainer = clickedDot.closest('[data-ele="stacked"]');

        if (!blockId || !parentContainer) {
            console.warn('Missing block ID or parent container.');
            return;
        }

        // Remove 'active-dot' from all slider dots
        const allDots = parentContainer.querySelectorAll('[data-ele="slider-dot"]');
        allDots.forEach(dot => dot.classList.remove('active-dot'));

        // Add 'active-dot' to the clicked dot
        clickedDot.classList.add('active-dot');

        // Remove 'active-slide' from all slides
        const allSlides = parentContainer.querySelectorAll('[data-ele="slider-slide"]');
        allSlides.forEach(slide => slide.classList.remove('active-slide'));

        // Add 'active-slide' to the corresponding slide
        const targetSlide = parentContainer.querySelector('[data-ele="slider-slide"][data-slide="' + blockId + '"]');

        if (targetSlide) {
            targetSlide.classList.add('active-slide');
        } else {
            console.warn(`Slide with data-slide="${blockId}" not found`);
        }

    } catch (error) {
        console.error('Slider dot click error:', error);
    }
});



document.addEventListener('theme:cart:add', function (e) {
  const button = e.detail.button;
  const formWrapper = button.closest('.form__wrapper') ||  button.closest('.product-quick-add__form');
  if (!formWrapper) return;

  const form = button.closest('form');
  if (!form) return;

  const selects = formWrapper.querySelectorAll('select[name^="properties["]');
  const customTextInput = formWrapper.querySelector('input[name="properties[Front Custom Text]"]');

  let allValid = true;

  // 🧩 Resync hidden inputs before validation
  selects.forEach((select) => syncHiddenInput(select, form));

  // 🧩 Validate dropdown selects
  selects.forEach((select) => {
    const selectedValue = select.value.trim();
    const existingError = select.parentElement.querySelector('.letter-error');
    if (existingError) existingError.remove();

    const firstOptionText = select.options[0]?.textContent.trim() || '';
    const isLetterSelect = /Letter/i.test(firstOptionText);
    const isNumberSelect = /Number/i.test(firstOptionText);

    if (/^Choose/i.test(selectedValue) || selectedValue === '') {
      allValid = false;
      const message = isLetterSelect
        ? 'Select a letter before adding to cart.'
        : isNumberSelect
        ? 'Select a number before adding to cart.'
        : 'Please make a selection before adding to cart.';
      showSelectError(select, message);
    } else {
      select.classList.remove('has-error');
    }

    // 🧩 Attach listener to clear error + resync on change
    if (!select.dataset.errorListenerAttached) {
      select.addEventListener('change', () => {
        const err = select.parentElement.querySelector('.letter-error');
        if (err) err.remove();
        select.classList.remove('has-error');
        syncHiddenInput(select, form);
      });
      select.dataset.errorListenerAttached = 'true';
    }
  });

  // 🧩 Validate & sync Front Custom Text
  if (customTextInput) {
    const value = customTextInput.value.trim();
    const min = parseInt(customTextInput.getAttribute('minlength')) || 3;
    const max = parseInt(customTextInput.getAttribute('maxlength')) || 8;

    const existingError = customTextInput.parentElement.querySelector('.letter-error');
    if (existingError) existingError.remove();

    if (value === '' || value.length < min || value.length > max) {
      allValid = false;
      const message = `Please enter ${min}-${max} characters before adding to cart.`;
      showSelectError(customTextInput, message);
    } else {
      customTextInput.classList.remove('has-error');
      syncHiddenInput(customTextInput, form); // ✅ Sync hidden input just like dropdowns
    }

    // 🧩 Clear error + resync hidden input on input
    if (!customTextInput.dataset.errorListenerAttached) {
      customTextInput.addEventListener('input', () => {
        const err = customTextInput.parentElement.querySelector('.letter-error');
        if (err) err.remove();
        customTextInput.classList.remove('has-error');
        //syncHiddenInput(customTextInput, form);
      });
      customTextInput.dataset.errorListenerAttached = 'true';
    }
    syncHiddenInput(customTextInput, form);
  }

  if (!allValid) {
    console.warn('Validation failed: missing or invalid inputs.');
    e.stopImmediatePropagation();
    e.preventDefault();
    return;
  }

  // ✅ If validation passes, dispatch validated event
  document.dispatchEvent(
    new CustomEvent('theme:cart:add:validated', { detail: e.detail })
  );
});

// 🔹 Live sync Front Custom Text input into hidden field
document.addEventListener('DOMContentLoaded', () => {
  const formWrappers = document.querySelectorAll('.product__wrapper');

  formWrappers.forEach((wrapper) => {
    const form = wrapper.querySelector('product-form form');
    if (!form) return;

    const customTextInput = wrapper.querySelector('input[name="properties[Front Custom Text]"]');
    if (customTextInput){
      // Initial sync (in case of prefilled input)
      syncHiddenInput(customTextInput, form);

      // Live update on typing
      customTextInput.addEventListener('input', () => {
        syncHiddenInput(customTextInput, form);
      });  
    }

    


    // ✅ Attach event delegation *within this wrapper's context*
    document.addEventListener('click', (event) => {
      const btn = event.target.closest('.ptc_button');
      if (!btn) return;
      
      // Gather all inputs/selects inside the wrapper
      const fields = wrapper.querySelectorAll(
        'input[name^="properties["], select[name^="properties["]'
      );
      console.log(fields);
      // Observe DOM for modal appearing
      const observer = new MutationObserver(() => {
        const modal = document.querySelector('.pplr_crop-modal');
        if (modal && modal.querySelector('form')) {
          const modalForm = modal.querySelector('form');
          console.log('modalForm', modalForm);
          fields.forEach((field) => {
            // console.log('fields', field);
            // const modalField = modalForm.querySelector(
            //   `[name="${CSS.escape(field.name)}"]`
            // );
            //if (modalField) {
              syncHiddenInput(field, modalForm); // sync current value
            //}
          });

          observer.disconnect(); // stop observing after syncing
        }else{
          console.log('modal Not Found');
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 10000);
    });


  });


      



});


// 🔧 Shared helper functions
function showSelectError(input, message) {
  input.classList.add('has-error');
  const error = document.createElement('div');
  error.className = 'letter-error';
  error.style.color = 'red';
  error.style.fontSize = '13px';
  error.style.marginTop = '4px';
  error.textContent = message;
  input.parentElement.appendChild(error);
}

function syncHiddenInput(input, form) {
  const name = input.getAttribute('name');
  // Don't copy if input is disabled
  if (input.disabled) return;

  const value = input.value.trim();
  const existing = form.querySelector(
    `input[type="hidden"][name="${CSS.escape(name)}"]`
  );

  // Remove hidden input if no valid value
  if (/^Choose/i.test(value) || value === '') {
    if (existing) existing.remove();
    return;
  }

  // Update or create hidden input
  if (existing) {
    existing.value = value;
  } else {
    const hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = name;
    hidden.value = value;
    hidden.setAttribute('data-properties-hidden', '');
    //form.appendChild(hidden);
    //form.prepend(hidden);
    // Check if name is specifically "properties[Shipping Estimation]"
    if (name == 'properties[Shipping Estimation]') {
        // Add to the end of the form
        form.appendChild(hidden);
    } else {
      // Check for existing anchor
      const anchor = form.querySelector(
        'input[type="hidden"][data-properties-hidden]'
      );
      if (anchor) {
        // Insert AFTER the anchor
        anchor.insertAdjacentElement('afterend', hidden);
      } else {
        // Default behavior: add to beginning
        form.prepend(hidden);
      }
    }
  }
}


function initLetterDropdowns() {
  const DEBOUNCE_MS = 150;

  function buildDropdowns() {
    const letterRadios = Array.from(
      document.querySelectorAll(
        '[data-product-variants] input[type="radio"][name^="options[Letter]"]'
      )
    );
    if (!letterRadios.length) return;

    const groups = new Map();
    letterRadios.forEach(radio => {
      const wrapper =
        radio.closest(".selector-wrapper") ||
        radio.closest("fieldset") ||
        radio.parentElement;

      if (!wrapper) return;
      if (!groups.has(wrapper)) groups.set(wrapper, []);
      groups.get(wrapper).push(radio);
    });

    groups.forEach((radios, wrapper) => {
      const radioButtonsWrapper =
        wrapper.querySelector(".radio__buttons[data-variant-buttons]") ||
        wrapper.querySelector(".radio__buttons") ||
        wrapper;

      wrapper.classList.add("letter-swatch-wrapper");

      let dropdown = wrapper.querySelector(".letter-mobile-dropdown");

      // Create dropdown if not exists
      if (!dropdown) {
        dropdown = document.createElement("select");
        dropdown.className = "letter-mobile-dropdown";
        dropdown.setAttribute("aria-label", "Select Letter");

        radios.forEach(radio => {
          const opt = document.createElement("option");
          opt.value = radio.value;
          opt.textContent = radio.value;
          if (radio.checked) opt.selected = true;
          dropdown.appendChild(opt);
        });

        radioButtonsWrapper.insertAdjacentElement("afterend", dropdown);

        dropdown.addEventListener("change", function () {
          const value = this.value;
          const target = radios.find(r => r.value === value);
          if (target) {
            target.checked = true;
            try {
              target.click();
            } catch (err) {
              target.dispatchEvent(new Event("change", { bubbles: true }));
            }
            target.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });

        radios.forEach(radio => {
          const syncHandler = () => {
            if (dropdown) dropdown.value = radio.value;
          };
          radio.addEventListener("click", syncHandler);
          radio.addEventListener("change", syncHandler);
        });
      } else {
        const existingValues = Array.from(dropdown.options).map(o => o.value);
        const radioValues = radios.map(r => r.value);

        const same =
          existingValues.length === radioValues.length &&
          existingValues.every((v, i) => v === radioValues[i]);

        if (!same) {
          dropdown.innerHTML = "";
          radios.forEach(radio => {
            const opt = document.createElement("option");
            opt.value = radio.value;
            opt.textContent = radio.value;
            if (radio.checked) opt.selected = true;
            dropdown.appendChild(opt);
          });
        } else {
          const checkedRadio = radios.find(r => r.checked);
          if (checkedRadio) dropdown.value = checkedRadio.value;
        }
      }
    });
  }

  // Run once immediately
  buildDropdowns();

  // Debounced resize watcher (optional)
  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(buildDropdowns, DEBOUNCE_MS);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initLetterDropdowns();
});


document.addEventListener('theme:quick-add:open', function (e) {
  console.log("quick iewww");
  initLetterDropdowns();
})

(function() {
  const originalDispatchEvent = EventTarget.prototype.dispatchEvent;
 
  EventTarget.prototype.dispatchEvent = function(event) {
    // Log only CustomEvent instances
    if (event instanceof CustomEvent) {
      console.group("CustomEvent Fired");
      console.log("Type:", event.type);
      console.log("Detail:", event.detail);
      console.log("Target:", this);
      console.groupEnd();
    }
 
    return originalDispatchEvent.call(this, event);
  };
})();



// (function () {
//   const MOBILE_MAX = 749;
//   const DEBOUNCE_MS = 150;

//   function buildOrRemoveDropdowns() {
//     const isMobile = window.innerWidth <= MOBILE_MAX;

//     // Find all radios that belong to options[Letter] (covers possible template suffix)
//     const letterRadios = Array.from(document.querySelectorAll('[data-product-variants] input[type="radio"][name^="options[Letter]"]'));
//     if (!letterRadios.length) return;

//     // Group radios by their selector-wrapper (so we handle each swatch group separately)
//     const groups = new Map();
//     letterRadios.forEach(radio => {
//       const wrapper = radio.closest('.selector-wrapper') || radio.closest('fieldset') || radio.parentElement;
//       if (!wrapper) return;
//       const key = wrapper; // element as key
//       if (!groups.has(key)) groups.set(key, []);
//       groups.get(key).push(radio);
//     });

//     groups.forEach((radios, wrapper) => {
//       // Find the radio buttons container inside that wrapper
//       const radioButtonsWrapper = wrapper.querySelector('.radio__buttons[data-variant-buttons]') || wrapper.querySelector('.radio__buttons') || wrapper;
//       // Add class so CSS only hides radio__buttons for this wrapper
//       wrapper.classList.add('letter-swatch-wrapper');

//       let dropdown = wrapper.querySelector('.letter-mobile-dropdown');

//       if (isMobile) {
//         // Create dropdown if missing
//         if (!dropdown) {
//           dropdown = document.createElement('select');
//           dropdown.className = 'letter-mobile-dropdown';
//           dropdown.setAttribute('aria-label', 'Select Letter');

//           // Populate options from radios
//           radios.forEach(radio => {
//             const opt = document.createElement('option');
//             opt.value = radio.value;
//             opt.textContent = radio.value;
//             if (radio.checked) opt.selected = true;
//             dropdown.appendChild(opt);
//           });

//           // Place right after radioButtonsWrapper
//           radioButtonsWrapper.insertAdjacentElement('afterend', dropdown);

//           // When dropdown changes → click matching radio (fires theme listeners)
//           dropdown.addEventListener('change', function () {
//             const value = this.value;
//             const target = radios.find(r => r.value === value);
//             if (target) {
//               // Ensure target is visible to event handlers: use click()
//               target.checked = true;
//               try {
//                 target.click();
//               } catch (err) {
//                 // fallback to dispatch change if click isn't allowed
//                 target.dispatchEvent(new Event('change', { bubbles: true }));
//               }
//               // also dispatch change to be safe
//               target.dispatchEvent(new Event('change', { bubbles: true }));
//             }
//           });

//           // Keep dropdown in sync when user clicks a radio (desktop)
//           radios.forEach(radio => {
//             // Use named function so we can remove if we rebuild
//             const syncHandler = () => {
//               if (dropdown) dropdown.value = radio.value;
//             };
//             radio.addEventListener('click', syncHandler);
//             radio.addEventListener('change', syncHandler);
//           });
//         } else {
//           // Dropdown exists, ensure it has up-to-date options & selected state
//           // (useful if variants changed dynamically)
//           // Rebuild options only if count mismatch or values differ
//           const existingValues = Array.from(dropdown.options).map(o => o.value);
//           const radioValues = radios.map(r => r.value);
//           const same =
//             existingValues.length === radioValues.length &&
//             existingValues.every((v, i) => v === radioValues[i]);

//           if (!same) {
//             // Rebuild
//             dropdown.innerHTML = '';
//             radios.forEach(radio => {
//               const opt = document.createElement('option');
//               opt.value = radio.value;
//               opt.textContent = radio.value;
//               if (radio.checked) opt.selected = true;
//               dropdown.appendChild(opt);
//             });
//           } else {
//             // Keep selection in sync
//             const checkedRadio = radios.find(r => r.checked);
//             if (checkedRadio) dropdown.value = checkedRadio.value;
//           }
//         }
//       } else {
//         // Desktop — remove dropdown if present
//         if (dropdown) {
//           // Remove event listeners by cloning (clean)
//           const newNode = dropdown.cloneNode(false);
//           dropdown.parentNode.replaceChild(newNode, dropdown);
//           newNode.remove();
//         }
//       }
//     });
//   }

//   // Run on load
//   document.addEventListener('DOMContentLoaded', buildOrRemoveDropdowns);

//   // Debounced resize handler
//   let resizeTimer;
//   window.addEventListener('resize', () => {
//     clearTimeout(resizeTimer);
//     resizeTimer = setTimeout(buildOrRemoveDropdowns, DEBOUNCE_MS);
//   });

// })();
